import { RESPONSIVE_BREAKPOINTS } from 'constants/Global/ResponsiveLayout.const';
import styled, { keyframes } from 'styled-components';

const FLOATING_HEIGHT = 64;
const FLOATING_GAP = 12;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Bar = styled.section`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
`;

export const Count = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: #595959;
`;

export const Floating = styled.section`
  position: fixed;
  right: ${FLOATING_GAP}px;
  bottom: calc(${FLOATING_GAP}px + env(safe-area-inset-bottom, 0px));
  left: ${FLOATING_GAP}px;
  z-index: 90;
  display: flex;
  gap: 4px;
  align-items: center;
  min-height: ${FLOATING_HEIGHT}px;
  padding: 10px 12px 10px 16px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.16);
  animation: ${slideUp} 0.2s ease-out;

  ${Count} {
    font-weight: 600;
    color: #262626;
  }

  .ant-btn-link {
    color: #595959;
  }

  @media (min-width: ${RESPONSIVE_BREAKPOINTS.tablet}px) {
    right: auto;
    left: 50%;
    width: 560px;
    transform: translateX(-50%);
    animation: none;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Action = styled.div`
  flex: none;

  .ant-btn {
    height: 44px;
  }

  .ant-btn-primary:not([disabled]) {
    color: #000;
    background: #f78e1e;
    border-color: #f78e1e;
  }
`;

export const FloatingSpace = styled.div`
  height: calc(
    ${FLOATING_HEIGHT + FLOATING_GAP * 2}px + env(safe-area-inset-bottom, 0px)
  );
`;
